import {
    TranscriptSummary,
    TranscriptSummaryBehaviour,
} from '../../../../../coaching-base/general';
import { BehaviourItem } from '../../../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../../../coaching-tags/models/subbehaviour.coaching.model';
import { TranscriptSummaryBehaviourView } from '../model/transcript-summary-behaviour-view.model';
import { TranscriptSummaryView } from '../model/transcript-summary-view.model';

import { transcriptDataTransformer } from './transcript-data.transformer';

function behaviourTransformer(
    val: TranscriptSummaryBehaviour,
    behaviours: BehaviourItem[],
    subBehaviours: SubBehaviourItem[],
): TranscriptSummaryBehaviourView {
    const behaviourName = behaviours?.find((e) => e.id === val.behaviourId)
        ?.name;
    return {
        behaviourId: val.behaviourId,
        behaviourName,
        transcripts: val.transcripts?.map((e) =>
            transcriptDataTransformer(e, behaviours, subBehaviours),
        ),
        behaviourNameWithCount: `${behaviourName ?? ''} (${
            val.transcripts?.length ?? 0
        })`,
    };
}

export function transcriptsSummaryTransformer(
    val: TranscriptSummary,
    behaviours: BehaviourItem[],
    subBehaviours: SubBehaviourItem[],
): TranscriptSummaryView {
    return {
        draft:
            val.draft?.map((e) =>
                behaviourTransformer(e, behaviours, subBehaviours),
            ) ?? [],
        active:
            val.active?.map((e) =>
                behaviourTransformer(e, behaviours, subBehaviours),
            ) ?? [],
        closed:
            val.closed?.map((e) =>
                behaviourTransformer(e, behaviours, subBehaviours),
            ) ?? [],
        nonAssociated:
            val.nonAssociated?.map((e) =>
                behaviourTransformer(e, behaviours, subBehaviours),
            ) ?? [],
    };
}
